import { Resource } from "../resource"


export class FAQ extends Resource {
    question: string
    text:string
 }